import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface ConfirmDisableDialogData {
  featureName: string;
  enabling: boolean;
}

@Component({
  selector: 'app-confirm-disable-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
  template: `
    <h2 mat-dialog-title>{{ data.enabling ? 'Enable' : 'Disable' }} feature flag</h2>
    <mat-dialog-content>
      <p>Are you sure you want to {{ data.enabling ? 'enable' : 'disable' }} <strong>{{ data.featureName }}</strong>?</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cancel()">Cancel</button>
      <button mat-flat-button [color]="data.enabling ? 'primary' : 'warn'" type="button" (click)="confirm()">
        {{ data.enabling ? 'Enable' : 'Disable' }}
      </button>
    </mat-dialog-actions>
  `
})
export class ConfirmDisableDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<ConfirmDisableDialogComponent>,
    @Inject(MAT_DIALOG_DATA) protected readonly data: ConfirmDisableDialogData
  ) {}

  protected cancel(): void {
    this.dialogRef.close(false);
  }

  protected confirm(): void {
    this.dialogRef.close(true);
  }
}
